(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('supplierAddAction', {
      controller: Controller,
      templateUrl: 'actions/supplier/add/add-supplier.action.html',
      bindings: {
        supplier: '<',
        then: '&',
        catch: '&'
      }
    });
}());
